<template>
  <div class="animated fadeIn">
    <Tables
      ref="tableGrid"
      :columns="[
        'Modelo',
        'Finalidade',
        'Tipo',
        'Data de Criação',
        $lang.Common.DataTable.Actions
      ]"
      :showNew="true"
      :showSearch="true"
      :showReload="true"
      :showTipFooter="false"
      v-on:New="onNew"
      v-on:Search="onShowSearch"
      v-on:Load="onLoad"
      v-on:Reload="onLoad"
    >
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inative ? 0 : 1"
          :value="obj.nome ? obj.nome.toUpperCase() : ''"
        />
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inative ? 0 : 1"
          :value="obj.finalidade ? onGetGoal(obj.finalidade) : ''"
        />
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inative ? 0 : 1"
          :value="obj.tipo ? onGetType(obj.tipo) : ''"
        />
        <TableColumn
          :IsDatetime="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inative ? 0 : 1"
          :value="obj.dataCriacao ? obj.dataCriacao : ''"
        />
        <TableColumn
          :IsActionsButtons="true"
          :HasChange="false"
          v-on:Delete="onDelete(obj)"
          :status="obj.status"
        />
      </tr>
    </Tables>

    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button
          type="button"
          class="btn btn-third btn-sm"
          v-on:click="$emit('New')"
          v-b-tooltip.hover
          :title="'Clique para cadastrar'"
        >
          <i class="fas fa-user-plus"></i>
          <span class="d-md-down-none">&nbsp; Novo</span>
        </button>
      </div>
    </div>
    <SidebarSearch @search="onSearch" />
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import TemplateRepository from '@/shared/http/repositories/configurations/templates.js'
import SidebarSearch from '@/views/private/configurations/campaign/templates/components/search/SidebarCampanhaModelo.vue'

export default {
  name: 'CampaignTemplateList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  components: {
    SidebarSearch
  },
  methods: {
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.push()
      if (this.filters) {
        let optionFilters = ''
        if (this.filters.nome) {
          optionFilters += `nome=${this.filters.nome}&`
        }
        if (this.filters.tipo) {
          optionFilters += `tipo=${this.filters.tipo}&`
        }
        TemplateRepository.Search(optionFilters, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
      } else {
        TemplateRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
      }
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      TemplateRepository.Delete(obj.id)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    onGetType (typeTemplate) {
      let result = ''
      if (typeTemplate) {
        switch (parseInt(typeTemplate)) {
          case 1: result = 'E-MAIL'
            break
          case 2: result = 'SMS'
            break
          case 3: result = 'WHATSAPP'
            break
        }
      }
      return result
    },
    onGetGoal (goal) {
      let result = ''
      if (goal) {
        switch (parseInt(goal)) {
          case 1: result = 'CAMPANHA'
            break
          case 2: result = 'PESQUISA'
            break
          case 3: result = 'LISTA INTELIGENTE'
            break
          case 4: result = 'CRM'
            break
        }
      }
      return result
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/campaign/templates/components/list/campanhamodelolist.vue